import classNames from 'classnames';
import { ISchedulingEvent, ISchedulingTimeOffEvent } from 'containers/scheduling/types/types';
import { getSchedulingColor, isSchedulingEventTimeOff } from '../../utils/utils';
import SchedulingEventDetails from '../SchedulingEventDetails/SchedulingEventDetails';
import SchedulingTimeOffEvent from '../SchedulingTimeOffEvent/SchedulingTimeOffEvent';

export interface ISchedulingEventProps {
  event: ISchedulingEvent | ISchedulingTimeOffEvent;
  className?: string | object;
}

const SchedulingEvent = ({ event, className }: ISchedulingEventProps) => {
  if (isSchedulingEventTimeOff(event)) {
    return <SchedulingTimeOffEvent event={event} />;
  } else {
    return (
      <SchedulingEventDetails
        time={event.title}
        color={getSchedulingColor(event.type, event.color)}
        type={event.type}
        members={event.members}
        project={event.project}
        costCode={event.costCode}
        equipment={event.equipment}
        className={classNames('scheduling-event', className)}
      />
    );
  }
};

export default SchedulingEvent;
